import styled from "styled-components";
import { Menu } from "antd";
import colors from "../../../../../css/colors";

export const StyledMenuItem = styled(Menu.Item)`
  .ant-menu-horizontal & {
    padding: 0;
    margin-right: 35px;
    margin-left: 35px;

    &:nth-child(2) {
      margin-left: 0;
    }

    .anticon {
      font-size: 20px;
    }

    > a {
      font-size: 16px;
      text-transform: uppercase;
      color: ${colors.GREY_ULTRA_LIGHT};

      &:hover,
      &:focus,
      &:active {
        text-decoration: none;
      }
    }

    &.ant-menu-item-selected,
    &:hover {
      > a {
        color: ${colors.BLUE};
      }

      border-bottom: 2px solid ${colors.BLUE};
    }
  }
`;
